export function setToSurvey(question) {
	const oldChoices=question.choices
	let newChoices=[]
	oldChoices.map(function(choice){
		const newChoice={
			body:choice.body,
			correct:false,
		}
		newChoices.push(newChoice)
		return null
	})
	question.choices=newChoices
	return question
}



